import { Clock } from 'lucide-react';

export const RISK_STYLES = {
  overdue: { label: 'Em atraso', dot: 'bg-red-500', text: 'text-red-500', ring: 'ring-red-500/30' },
  critical: { label: 'Crítico', dot: 'bg-orange-500', text: 'text-orange-500', ring: 'ring-orange-500/30' },
  warning: { label: 'Atenção', dot: 'bg-amber-400', text: 'text-amber-500', ring: 'ring-amber-400/30' },
  ok: { label: 'Dentro do prazo', dot: 'bg-emerald-500', text: 'text-emerald-500', ring: 'ring-emerald-500/30' },
  closed: { label: 'Concluído', dot: 'bg-slate-400', text: 'text-slate-400', ring: 'ring-slate-400/30' },
  unknown: { label: 'Sem data', dot: 'bg-slate-400', text: 'text-slate-400', ring: 'ring-slate-400/30' },
};

export const DeadlineLight = ({ request, dark = false }) => {
  const style = RISK_STYLES[request.risk_level] || RISK_STYLES.unknown;
  const days = request.days_left;
  const caption =
    request.risk_level === 'closed'
      ? 'prazo encerrado'
      : days === null || days === undefined
        ? 'sem data de pedido'
        : days < 0
          ? `${Math.abs(days)} dia(s) em atraso`
          : `${days} dia(s) restantes`;

  return (
    <div className="flex items-center gap-3" data-testid={`deadline-light-${request.rtbf_id}`}>
      <span className={`w-2.5 h-2.5 rounded-full shrink-0 ${style.dot} ring-4 ${style.ring}`} />
      <div className="leading-tight">
        <p className={`text-sm font-medium ${dark ? style.text.replace('-500', '-400') : style.text}`}>
          {style.label}
          {request.extended && (
            <span
              className="ml-2 text-xs font-normal px-1.5 py-0.5 rounded bg-blue-500/15 text-blue-500"
              title={request.extension_justification || 'Prazo prorrogado (RGPD art. 12(3))'}
              data-testid={`extension-badge-${request.rtbf_id}`}
            >
              prorrogado +{request.extension_months}m
            </span>
          )}
        </p>
        <p className={`text-xs ${dark ? 'text-slate-500' : 'text-slate-500'} flex items-center gap-1`}>
          <Clock className="w-3 h-3" /> {caption}
        </p>
      </div>
    </div>
  );
};

export default DeadlineLight;
